import React, { Component, Fragment } from 'react';
import api from '../../../services/api';
import ModalConfirm from '../../common/modal-confirm';
import ModalAlert from '../../common/modal-alert';
import Pagination from '../../../components/Common/pagination';
class Permission extends Component {

    state = {
        load: false,
        companies: {},
        erroDelete: false,
        insertCompanyType: false,
        msgError: null,
        msgSuccess: null,
        nameCompanyType: '',
        idCompanyType: null,
        registerEmployee: true,
        classText: '',
        paginas:0
    }

    componentDidMount() {
        this.searchCompanies();
    }

    searchCompanies = async (e) => {
        let page = (e)?e.target.id:1;
        this.setState({ load: true });
        const response = await api.get(`/company-types?order_by=id&order_direction=DESC&page=${page}`);
        this.setState({ companies: response.data.rows, load: false, paginas:Math.ceil(response.data.count/10) });
    }

    insertCompanyType = () => {
        document.getElementById('nameCompanyType').value = '';

        this.setState({
            insertCompanyType: true,
            msgError: null,
            msgSuccess: null
        });
    }

    createCompanyType = async () => {
        try {
            let response = await api.post(`/company-types`, this.buildCompanyType());
            this.searchCompanies();
            document.getElementById('nameCompanyType').value = '';
            this.setState({ msgError: null, msgSuccess: response.data.msg });
        } catch (err) {
            this.setState({ msgError: err.response.data.errors[0].msg, msgSuccess: null });
        }
    }

    updateStatus = async (e) => {
        const id = e.target.id;
        const value = (e.target.name == 1) ? 0 : 1;
        document.getElementById("modal-alert").click();
        try {
            const response = await api.put(`/company-types/${id}`, { status: value });
            this.searchCompanies();
            this.setState({ msgAlert: response.data.msg, classText: "text-success" });
        } catch (err) {
            this.setState({ msgAlert: err.response.data.errors[0].msg, classText: "text-danger" });
        }
    }

    alterCompanyType = (e) => {
        const id = e.target.id;
        const company = this.state.companies.filter((item) => (item.id == id));
        document.getElementById("nameCompanyType").value = company[0].description;
        document.getElementById("registerEmployee").checked = company[0].register_employee;

        this.setState({
            msgError: null,
            msgSuccess: null,
            idCompanyType: id,
            nameCompanyType: company[0].description,
            registerEmployee: company[0].register_employee
        });
    }

    buildCompanyType = () => {
        return {
            description: document.getElementById('nameCompanyType').value, 
            register_employee: document.getElementById('registerEmployee').checked
        }
    }

    confirmAlterCompanyType = async (e) => {
        try {
            let response = await api.put(`/company-types/${this.state.idCompanyType}`, this.buildCompanyType());
            this.searchCompanies();
            this.setState({ msgError: null, msgError: null, msgSuccess: response.data.msg });
        } catch (err) {
            this.setState({ msgError: err.response.data.errors[0].msg, msgSuccess: null });
        }
    }

    deleteCompanyType = async (e) => {
        const id = e.target.id;
        if (id) {
            this.setState({ idCompanyType: id, erroDelete: null });
            document.getElementById("modal-confirm").click();
        }
    }

    confirmDeleteCompanyType = async () => {
        this.setState({ load: true });
        try {
            const response = await api.delete(`/company-types/${this.state.idCompanyType}`);
            this.searchCompanies();
            this.setState({ load: false, idCompanyType: null, erroDelete: null });
            document.getElementById('close-modal-confirm').click();

            document.getElementById("modal-alert").click();
            this.setState({ msgAlert: response.data.msg, classText: "text-success" });

        } catch (err) {
            let msg = (err.response.data.errors) ? err.response.data.errors[0].msg : err.response.data.msg;
            this.setState({ erroDelete: msg });
        };
    }

    handleRegisterEmployee = (e) => {
        this.setState({registerEmployee: e.target.checked});
    }

    render() {
        return (
            <Fragment>
                <div className="row page-titles">
                    <div className="col-md-5 col-8 align-self-center">
                        <h3 className="text-themecolor">Tipos de Empresa
                        {(this.state.load) ? <i className="fa fa-spin fa-spinner"></i> : null}
                        </h3>
                    </div>
                </div>
                <div className="row">
                    <div className="col-md-12">
                        <div className="card">

                            <div className="p-20 text-right">
                                <div className="col-md-2 btn btn-rounded btn-primary" data-toggle="modal" data-target=".modal-alter-document" onClick={this.insertCompanyType}>Cadastrar</div>
                            </div>

                            <table className="table table-bodered">
                                <thead>
                                    <tr>
                                        <th>ID</th>
                                        <th>Tipo de Empresa</th>
                                        <th>Registra funcionários</th>
                                        <th>Status</th>
                                        <th>Editar</th>
                                        <th>Excluir</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {(this.state.companies.length) ?
                                        (this.state.companies).map((item) => {
                                            return (
                                                <tr key={item.id}>
                                                    <td>{item.id}</td>
                                                    <td>{item.description}</td>
                                                    <td>{item.register_employee ? 'Sim' : 'Não'}</td>
                                                    <td className="td-button" id={item.id}>
                                                        <div className="switch">
                                                            <label>
                                                                <input type="checkbox" defaultChecked={item.status} id={item.id} name={item.status} onChange={this.updateStatus} /><span className="lever"></span>
                                                            </label>
                                                        </div>
                                                    </td>
                                                    <td className="td-button">
                                                        <button type="button" id={item.id} onClick={this.alterCompanyType} data-toggle="modal" data-target=".modal-alter-document" className="btn btn-sm btn-outline-success btn-circle">
                                                            <i id={item.id} className="fa fa-edit"></i>
                                                        </button>
                                                    </td>
                                                    <td className="td-button">
                                                        <button type="button" id={item.id} onClick={this.deleteCompanyType} className="btn btn-sm btn-outline-danger btn-circle">
                                                            <i id={item.id} className="fa fa-times"></i>
                                                        </button>
                                                    </td>
                                                </tr>
                                            )
                                        })
                                        : null}
                                </tbody>
                            </table>
                            <Pagination function={this.searchCompanies} paginas={this.state.paginas} />
                        </div>
                    </div>
                </div>

                <ModalConfirm title="Confirmação" msg="Tem certeza que deseja excluir o tipo da empresa?" function={this.confirmDeleteCompanyType} msgError={this.state.erroDelete} />
                <ModalAlert title="Informação" msg={this.state.msgAlert} function="" classText={this.state.classText} />

                <div className="modal fade modal-alter-document" data-backdrop="static" role="dialog" aria-labelledby="myLargeModalLabel" aria-hidden="true">
                    <div className="modal-dialog modal-lg">
                        <div className="modal-content">
                            <div className="modal-header">
                                <h5 className="modal-title" id="myLargeModalLabel">
                                    {(this.state.insertCompanyType) ? 'Cadastrar ' : 'Alterar '}
                                    Tipo de Empresa
                                {(this.state.load) ? <i className="fa fa-spin fa-spinner"></i> : null}
                                </h5>
                                <button type="button" className="close" data-dismiss="modal" aria-hidden="true">×</button>
                            </div>
                            <div className="modal-body">
                                <form>
                                    <div className="row">
                                        <div className="col-md-12">
                                            <span>Tipo da empresa <i className="text-danger">*</i></span>
                                            <input type="text" id="nameCompanyType" className="form-control" defaultValue={this.state.nameCompanyType}></input>
                                        </div>
                                        <div className="col-md-6 form-inline">
                                            <span style={{marginTop: '10px'}}>Registra funcionários</span>
                                            <div className="switch">
                                                <label>
                                                    <input 
                                                        type="checkbox" 
                                                        id="registerEmployee" 
                                                        onChange={this.handleRegisterEmployee} 
                                                        checked={this.state.registerEmployee}
                                                    />
                                                    <span 
                                                        style={{marginTop: '10px'}}
                                                        className="lever">
                                                    </span>
                                                </label>
                                            </div>
                                        </div>
                                        {(this.state.msgError || this.state.msgSuccess) ?
                                            <div className="col-md-12 p-t-20">
                                                <div className={(this.state.msgSuccess) ? 'alert alert-success' : 'alert alert-danger'}>
                                                    {this.state.msgError}
                                                    {this.state.msgSuccess}
                                                </div>
                                            </div>
                                            : null}

                                    </div>
                                </form>
                            </div>
                            <div className="modal-footer">
                                {(this.state.insertCompanyType) ?
                                    <button className="col-md-2 btn waves-effect waves-light btn-rounded btn-success" onClick={this.createCompanyType}>
                                        Cadastrar
                            </button>
                                    :
                                    <button className="col-md-2 btn waves-effect waves-light btn-rounded btn-success" onClick={this.confirmAlterCompanyType}>
                                        Alterar
                                </button>
                                }

                                <button type="button" id="closeModalCreate" className="col-md-2 btn btn-secondary btn-rounded waves-effect" data-dismiss="modal">Fechar</button>
                            </div>
                        </div>
                    </div>
                </div>
            </Fragment >
        )
    }
}

export default Permission;